import { handleActions } from 'redux-actions';
import { PLACE_TRASH, SHOW_TRASH, HIDE_TRASH } from '../actions/TrashActions';

const initialState = {
  left: 0,
  show: false,
};

export const TrashReducer = handleActions({
  [PLACE_TRASH]: (state, action) => ({ ...state, left: action.payload }),
  [SHOW_TRASH]: (state) => ({ ...state, show: true }),
  [HIDE_TRASH]: (state) => ({ ...state, show: false }),
}, initialState);
